/* Fourteen days of message volume, as bars.

   The console's tenant table answered "how much today" and "how much ever",
   which cannot tell a client who is ramping up from one who stopped streaming a
   week ago — the two facts an operator actually acts on. Bars rather than a
   line: the series is short, integral and often zero, and a line through a
   fortnight of zeroes implies a continuity that isn't there. */

interface Props {
  values: number[];
  label: string;
}

export function Sparkline({ values, label }: Props) {
  const peak = Math.max(...values, 1);
  const total = values.reduce((sum, value) => sum + value, 0);

  return (
    <span
      className="spark"
      role="img"
      aria-label={`${label}: ${total} in the last ${values.length} days`}
      title={`${total} in the last ${values.length} days`}
    >
      {values.map((value, at) => (
        <i
          key={at}
          /* A day with traffic never rounds down to an invisible sliver, so
             "one message" and "none at all" stay distinguishable. */
          style={{ height: `${value === 0 ? 8 : 8 + (value / peak) * 92}%` }}
          className={value === 0 ? "empty" : ""}
        />
      ))}
    </span>
  );
}
